import { CKEditor } from '@ckeditor/ckeditor5-react';
import { FnPEditor, fnpEditorConfig } from './FnPEditorConfig';
import styles from './FnPEditor.module.css';

function FnPEditorComponent(props: any) {
    return (
        <div>
            <h2 className={styles.reminderHeader}>Reminder</h2>
            <h3 className={styles.reminderSubHeader}>Mail body text</h3>
            <CKEditor
                editor={FnPEditor}
                config={fnpEditorConfig}
                data={props.data}
                onChange={(event, editor) => {
                    const data = editor.getData();
                    props.onItemsProcessed(data);
                }}
            />
        </div>
    );
}

export default FnPEditorComponent;
